module.exports = __webpack_public_path__ + "img/Deaminasevariants_N.9b2f384a.svg";